export const blockIconsTravelFitnessCenterNew = (
	<span className='material-symbols-outlined'>fitness_center</span>
);
